<template>
	<div>
		<template v-if="add_game_screen">
			<div class="row gutter-sm">
				<div class="col-xs-12 col-sm-12">
					<q-select
						v-model="game_type"
						:options="
							game_types
								.filter((e) => e.id !== 1 && e.id !== 4)
								.map((e) => ({ label: $t(e.slug), value: e.id }))
						"
						:disable="id_game !== 0 ? true : false"
						:float-label="$t('game_type')"
						@input="changeGame"
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="game_type">
					<q-alert color="secondary" icon="fas fa-exclamation-triangle">
						{{ $t(getGameTypeDescription) }}
					</q-alert>
				</div>

				<div class="col-xs-12 col-sm-12">
					<q-field :count="256">
						<q-input
							v-model="title"
							:float-label="$t('title')"
							:error="$v.title.$error"
							@input="$v.title.$touch"
						/>
					</q-field>
				</div>

				<div class="col-xs-12 col-sm-12">
					<q-field :count="256">
						<q-input
							v-model="description"
							ref="description"
							:float-label="$t('introduction')"
							rows="1"
							:max-height="100"
							type="textarea"
							:error="$v.description.$error"
							@input="$v.description.$touch"
						/>
					</q-field>
				</div>

				<div class="col-xs-12 col-sm-4">
					<q-datetime
						v-model="avaliable_in"
						type="date"
						:float-label="$t('avaliable_in')"
						format="DD/MM/YYYY"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-4">
					<q-field :helper="$t('leave_it_blank_to_use_training_score')">
						<q-input
							v-model="score"
							type="number"
							:float-label="$t('score')"
							:error="$v.score.$error"
							@input="$v.score.$touch"
						/>
					</q-field>
				</div>

				<div class="col-xs-12 col-sm-4 text-center">
					<q-checkbox
						class="q-mt-md q-mr-md"
						v-model="allow_to_skip"
						:val="false"
						:label="$t('allow_to_skip_game')"
					/>
					<q-icon
						name="far fa-question-circle"
						size="1.5rem"
						color="grey"
						class="q-mr-sm q-pt-md"
					>
						<q-tooltip class="custom-tooltip" anchor="top left" self="bottom right">
							{{ $t('allow_to_skip_game_tooltip') }}
						</q-tooltip>
					</q-icon>
				</div>
			</div>

			<div>
				<component
					v-if="selected_game"
					:is="selected_game"
					:id_game="id_game"
					:saved_game_data="game_data"
					@save_toggle="saveToggle"
					@save_game_data="saveGameData"
				/>
			</div>

			<div class="row gutter-sm q-mt-md">
				<div class="col-xs-12 col-sm-4">
					<p class="caption">{{ $t('status') }}</p>
					<q-btn-toggle
						v-model="status"
						:toggle-color="getColorStatusButton"
						:options="statuses"
					/>
				</div>
			</div>

			<div class="row gutter-sm justify-end q-mt-lg">
				<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
					<q-btn
						color="tertiary"
						class="full-width"
						:label="$t('back')"
						icon="fas fa-chevron-left"
						@click="returnToGames()"
					/>
				</div>

				<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
					<q-btn
						color="secondary"
						:disable="!can_save"
						class="full-width"
						:label="$t('save')"
						icon="far fa-save"
						@click="saveGame('save_game')"
					>
						<q-tooltip v-if="!can_save">
							{{
								id_game
									? $t('cant_update_game_tooltip')
									: $t('cant_save_game_tooltip')
							}}
						</q-tooltip>
					</q-btn>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, maxValue, minValue, maxLength } from 'vuelidate/lib/validators'
import { date } from 'quasar'
const { formatDate, buildDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
	name: 'AdminNewGame',

	props: ['add_game_screen', 'id_training', 'id_game'],

	data() {
		return {
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 0,
				descending: false,
				sortBy: null,
			},
			loading: false,
			title: '',
			description: '',
			game_type: 2,
			selected_game: 'drag-and-drop',
			allow_to_skip: false,
			status: 2,
			score: '',
			avaliable_in: null,
			statuses: [
				{ label: this.$t('published'), value: 1 },
				{ label: this.$t('unpublished'), value: 2 },
			],
			game_data: null,
			action_id: null,
			confirm_remove: false,
			can_save: false,
		}
	},

	components: {
		'drag-and-drop': () => import('./DragNDrop.vue'),
		'drag-the-words': () => import('./DragTheWords.vue'),
		'fill-in-the-blanks': () => import('./FillInTheBlanks.vue'),
		'find-the-words': () => import('./FindTheWords.vue'),
		flashcards: () => import('./Flashcards.vue'),
		'find-the-pairs': () => import('./FindThePairs.vue'),
		'this-or-that': () => import( './ThisOrThat.vue' ),
		'true-or-false': () => import('./TrueOrFalse.vue'),
		enigma: () => import('./Enigma.vue'),
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			game_types: 'registration_lists/group_training_game_types',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getColorStatusButton() {
			if (this.status == true) return 'positive'
			else return 'negative'
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		getGameTypeDescription() {
			let slug = this.getGameTypeSlug(this.game_type)
			return `${slug}_description`
		},
	},

	methods: {
		loadGame() {
			if (this.id_game != 0) {
				this.$q.loading.show()

				this.$axios
					.get(
						`/admin_group_trainings/group_trainings/${
							this.id_training
						}/group_training_games/${this.id_game}/`,
						this.getHeader
					)
					.then((response) => {
						let res = response.data

						this.add_game_screen = true
						this.game_type = res.group_training_game_type
						this.game_data = JSON.parse(res.params)
						this.changeGame()

						this.title = res.title
						this.description = res.description
						res.score ? (this.score = res.score) : (this.score = null)
						this.allow_to_skip = res.allow_to_skip
						this.status = res.status
						this.avaliable_in = res.avaliable_in
							? moment(res.avaliable_in)
									.tz('Etc/GMT')
									.format('YYYY-MM-DDTHH:mm:ss.SSS')
							: null

						this.$q.loading.hide()
					})
					.catch((e) => {
						this.$q.loading.hide()
						console.log(e)
					})
			} else {
				this.title = ''
				this.description = ''
				this.game_type = 2
				this.selected_game = 'drag_the_words'
				this.status = 2
				this.score = null
				this.avaliable_in = null
			}
		},

		saveGame() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let data = {
					title: this.title,
					description: this.description,
					avaliable_in: date.formatDate(this.avaliable_in, 'YYYY-MM-DD'),
					group_training_game_type: this.game_type,
					allow_to_skip: this.allow_to_skip,
					status: this.status,
					params: JSON.stringify(this.game_data),
				}
				if (this.score) data.score = this.score

				if (this.id_game != 0) {
					this.$axios
						.put(
							`/admin_group_trainings/group_trainings/${
								this.id_training
							}/group_training_games/${this.id_game}/`,
							data,
							this.getHeader
						)
						.then((response) => {
							this.$q.notify({
								message: this.$t('game_save_success'),
								type: 'positive',
								icon: 'far fa-save',
							})

							this.$q.loading.hide()
						})
						.catch((e) => {
							this.$q.loading.hide()

							this.$q.notify({
								message: this.$t('game_save_error'),
								type: 'negative',
								icon: 'fas fa-ban',
							})

							console.log(e)
						})
				} else {
					this.$axios
						.post(
							`/admin_group_trainings/group_trainings/${
								this.id_training
							}/group_training_games/`,
							data,
							this.getHeader
						)
						.then((response) => {
							this.$q.loading.hide()
							this.$v.$reset()

							this.$q.notify({
								message: this.$t('game_save_success'),
								type: 'positive',
								icon: 'far fa-save',
							})

							this.$emit('changeIdGame', response.data.id)

							this.returnToGames()
						})
						.catch((e) => {
							this.$q.loading.hide()

							this.$q.notify({
								message: this.$t('game_save_error'),
								type: 'negative',
								icon: 'fas fa-ban',
							})

							console.log(e)
						})
				}
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fas fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		getGameTypeSlug(id) {
			let obj = this.game_types.find((obj) => obj.id === id)
			if (obj) return obj.slug
			else return ''
		},

		getStatus(status) {
			if (status == 1) return 'published'
			else if (status == 2) return 'unpublished'
			else if (status == 3) return 'deleted'
		},

		getIconStatus(status) {
			if (status == 1) return 'fas fa-check'
			else if (status == 2) return 'fas fa-ban'
			else if (status == 3) return 'fas fa-trash-alt'
		},

		getColorStatus(status) {
			if (status == 1) return 'positive'
			else if (status == 2) return 'warning'
			else if (status == 3) return 'negative'
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		saveToggle(value) {
			this.can_save = value
		},

		saveGameData(value) {
			this.game_data = value
		},

		returnToGames() {
			this.title = ''
			this.description = ''
			this.game_type = 2
			this.status = 2
			this.avaliable_in = null
			this.score = null
			this.game_data = null

			this.$v.$reset()

			this.$emit('returnToGames', '')
		},

		changeGame() {
			if (this.game_type == 1) this.selected_game = 'drag-and-drop'
			else if (this.game_type == 2) this.selected_game = 'drag-the-words'
			else if (this.game_type == 3) this.selected_game = 'fill-in-the-blanks'
			else if (this.game_type == 4) this.selected_game = 'find-the-words'
			else if (this.game_type == 5) this.selected_game = 'flashcards'
			else if (this.game_type == 6) this.selected_game = 'this-or-that'
			else if (this.game_type == 7) this.selected_game = 'find-the-pairs'
			else if (this.game_type == 8) this.selected_game = 'enigma'
			else if (this.game_type == 9) this.selected_game = 'true-or-false'
			else this.selected_game = 'drag-the-words'
		},
	},

	mounted() {
		if (this.id_game !== 0) this.loadGame()
		else this.changeGame()
	},

	watch: {
		id_game: function() {
			if (this.id_game != 0) this.loadGame()
		},
	},

	validations() {
		return {
			title: { required, maxLength: maxLength(256) },
			description: { required, maxLength: maxLength(256) },
			game_type: { required },
			game_data: { required },
			score: { minValue: minValue(0) },
		}
	},
}
</script>

<style lang="stylus" scoped>
.custom-tooltip
    width 450px
    font-size 0.9rem
    padding 0.8rem
</style>
